import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import UsersTable from '../../ui/table'
import AvatarLink from '../avatarLink/avatarLink'

import { ColumnDescription } from 'react-bootstrap-table-next'

import { unblockUser } from '../../../store/member/memberSlice'
import { BlacklistItem } from '../../../store/member/memberTypings'
import { RootState } from '../../../store/rootReducer'

import moment from 'moment-mini'
import './blacklist.sass'

interface Props {
    userBlacklist: BlacklistItem[]
    nickDirection: boolean
    setNickDirection: React.Dispatch<boolean>
    dateDirection: boolean
    setDateDirection: React.Dispatch<boolean>
}

const List: React.FunctionComponent<Props> = ({
    userBlacklist,
    nickDirection,
    setNickDirection,
    dateDirection,
    setDateDirection
}: Props) => {
    const [t] = useTranslation()
    const dispatch = useDispatch()

    const { blacklistTotal } = useSelector((state: RootState) => state.member)

    const changeDirection = (param: string) => {
        if (param === 'banned_user.nick') {
            setNickDirection(!nickDirection)
            setDateDirection(null)
        }
        if (param === 'date') {
            setDateDirection(!dateDirection)
            setNickDirection(null)
        }
    }

    const sortCaret = (order: string, column: ColumnDescription & { label: string }) => (
        <div className={`sort ${order}`} onClick={() => changeDirection(column.dataField)}>
            <div className="text">{column.label}</div>
            <div className="arrow" />
        </div>
    )

    const unblock = (cell: string, row: BlacklistItem) => (
        <div
            onClick={(event) => {
                event.stopPropagation()
                dispatch(unblockUser({ blacklisted_user_id: row.banned_user.id }))
            }}
            className="unblock"
        >
            {t('unblock')}
        </div>
    )

    const avatar = (cell: string) => <AvatarLink img={cell} nick={cell.split('/')[2]} />

    const columns = [
        {
            dataField: 'banned_user.avatar_url',
            text: '',
            formatter: avatar
        },
        {
            sort: true,
            //@ts-ignore
            sortFunc: () => null,
            dataField: 'banned_user.nick',
            label: t('Nick'),
            sortCaret,
            text: ''
        },
        {
            sort: true,
            //@ts-ignore
            sortFunc: () => null,
            dataField: 'date',
            label: t('Adding date'),
            sortCaret,
            formatter: (cell: number) => {
                return moment(cell * 1000).format(t('time format'))
            },
            text: '',
            classes: 'addingDate'
        },
        {
            dataField: 'expiration_date',
            text: t('Time of blocking'),
            classes: 'period',
            formatter: (cell: number) => {
                if (cell) {
                    return moment(cell * 1000).format(t('time format'))
                } else {
                    return t('Permanent')
                }
            }
        },
        {
            dataField: 'reason',
            text: t('Reason')
        },
        {
            dataField: '',
            text: '',
            formatter: unblock
        }
    ]

    return (
        <div className="usersList">
            {userBlacklist.length ? (
                <UsersTable
                    title={t('List of blocked users')}
                    columns={columns}
                    blacklistItems={userBlacklist}
                    listLength={blacklistTotal}
                />
            ) : (
                <div className="empty">{t('There are no users in your blacklist')}</div>
            )}
        </div>
    )
}

export default List
